import { render, staticRenderFns } from "./StaffTypologyEdit.vue?vue&type=template&id=cec9e752&"
import script from "./StaffTypologyEdit.vue?vue&type=script&lang=js&"
export * from "./StaffTypologyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports